import { css } from '@emotion/css';

export const spinnerClassName = css({
  position: 'absolute',
  top: 'calc(50% - 16px)',
  left: 'calc(50% - 16px)',
});

export const iconClassName = css({
  color: '#CFCFCF',
  height: 32,
  width: 32,
});
